var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;



//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/~/lodash/_defineProperty.js
// module id = ./node_modules/victory-chart/node_modules/lodash/_defineProperty.js
// module chunks = 1